export default __webpack_public_path__ + "static/1634-3d87aa8ba8e0555afeb36b06738f98e4.gif";